import { FunctionComponent } from 'react';
import { CircularProgress } from '@mui/material';

interface LoadingIndicatorProps {
  size?: number;
}

export const LoadingIndicator: FunctionComponent<LoadingIndicatorProps> = ({ size = 16 }) => {
  return <CircularProgress className="loading-indicator" color="inherit" size={size} />;
};
